import { create } from 'zustand';
import {
	IActionInsightsDetails,
	IActionStatesEndpoint,
} from '../types/ActionPlanInterfaces';

export type serviceIdStore = {
	issueDataStore: IActionInsightsDetails | null;
	setIssueDataStore: (issueDataStore: IActionInsightsDetails) => void;
	acceptedActionsStore: IActionStatesEndpoint | null;
	setAcceptedActionsStore: (acceptedActionStore: IActionStatesEndpoint) => void;
	minAlertStore: boolean;
	setMinAlertStore: (minAlertStore: boolean) => void;
	teamTagStore: string[] | null;
	setTeamTagStore: (teamTagStore: string[]) => void;
	activeRoundNumberStore: number | null;
	setActiveRoundNumberStore: (activeRoundNumberStore: number) => void;
	amountRoundNumberStore: number | null;
	setAmountRoundNumberStore: (activeRoundNumberStore: number) => void;
};
export const useServiceIdStore = create<serviceIdStore>((set) => ({
	issueDataStore: null,
	acceptedActionsStore: null,
	minAlertStore: false,
	teamTagStore: null,
	activeRoundNumberStore: null,
	amountRoundNumberStore: null,
	setIssueDataStore: (issueDataStore: IActionInsightsDetails) =>
		set(() => ({ issueDataStore })),
	setAcceptedActionsStore: (acceptedActionsStore: IActionStatesEndpoint) =>
		set(() => ({ acceptedActionsStore })),
	setMinAlertStore: (minAlertStore: boolean) => set(() => ({ minAlertStore })),
	setTeamTagStore: (teamTagStore: string[]) => set(() => ({ teamTagStore })),
	setActiveRoundNumberStore: (activeRoundNumberStore: number) =>
		set(() => ({ activeRoundNumberStore })),
	setAmountRoundNumberStore: (amountRoundNumberStore: number) =>
		set(() => ({ amountRoundNumberStore })),
}));
